var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Circled3Indigo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "48px",
    height: "48px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#8783d1",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.33333,5.33333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,4c-11.046,0 -20,8.954 -20,20c0,11.046 8.954,20 20,20c11.046,0 20,-8.954 20,-20c0,-11.046 -8.954,-20 -20,-20zM24,7c9.374,0 17,7.626 17,17c0,9.374 -7.626,17 -17,17c-9.374,0 -17,-7.626 -17,-17c0,-9.374 7.626,-17 17,-17zM23.75,14c-3.46,0 -5.36922,2.49361 -5.44922,2.59961c-0.497,0.662 -0.36417,1.60261 0.29883,2.09961c0.662,0.498 1.60261,0.36417 2.09961,-0.29883c0.01,-0.014 1.10478,-1.40039 3.05078,-1.40039c1.517,0 2.75,1.233 2.75,2.75c0,1.517 -1.233,2.75 -2.75,2.75h-0.25c-0.829,0 -1.5,0.671 -1.5,1.5c0,0.829 0.671,1.5 1.5,1.5h0.5c1.654,0 3,1.233 3,2.75c0,1.517 -1.346,2.75 -3,2.75c-2.094,0 -3.26798,-1.36436 -3.33398,-1.44336c-0.516,-0.638 -1.45361,-0.74342 -2.09961,-0.23242c-0.649,0.516 -0.75719,1.46037 -0.24219,2.10938c0.084,0.105 2.08078,2.56641 5.67578,2.56641c3.309,0 6,-2.58 6,-5.75c0,-1.784 -0.85155,-3.37955 -2.18555,-4.43555c1.041,-1.041 1.68555,-2.47945 1.68555,-4.06445c0,-3.17 -2.58,-5.75 -5.75,-5.75z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Circled3Indigo);
export default __webpack_public_path__ + "static/media/icons8-circled-3-indigo.a48414745dcd947f8b4248773cb7248a.svg";
export { ForwardRef as ReactComponent };